import React from 'react';
import PropTypes from 'prop-types';

const Header = (props) => {
  const { fastCashId, onButtonClick } = props;
  return (
    <div className="header">
      <div className="form-header">
        <h3>Cashbacks list</h3>
        <div className="form-header-actions">
          {fastCashId && (
            <div
              id="add_cashback"
              className="button -add-button"
              onClick={onButtonClick}
            >
              Add FastCash For Cash Purchase
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  fastCashId: PropTypes.string,
  onButtonClick: PropTypes.func.isRequired,
};

Header.deafaultProps = {
  fastCashId: null,
};
